export default function resizeThrottler () {
  let resizeTimeout;
  return function (callback, ms) {
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        resizeTimeout = null;
        callback();
      }, ms);
    }
  };
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/resizeThrottler.js